module.exports = __webpack_public_path__ + "img/icon-car-2.54b82942.png";